<template>
  <a-layout class="full-window">
    <a-layout-content class="layout-content">
      <div class="main-content">
        <slot></slot>
      </div>
      <div class="navigation-container">
        <navigation-bar></navigation-bar>
      </div>
      <add-home-overlay />
    </a-layout-content>
  </a-layout>
</template>
<script lang="ts" setup>
import NavigationBar from '@/components/core/mobile/navigation-bar.vue'
import AddHomeOverlay from '@/components/core/mobile/add-home-overlay.vue'
defineOptions({
  name: 'MainLayoutMobile',
  displayName: 'MainLayoutMobile'
})
</script>
<style scoped lang="scss">
.full-window {
  display: flex;
  flex-direction: column;
  height: 100vh;
}
.layout-content {
  background-color: var(--color-background);
}
.navigation-container {
  padding: 0 25px 20px 25px;
}
:deep(.ant-layout-content) {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
}

.main-content {
  display: flex;
  justify-content: center;
  align-items: end;
  overflow: scroll;
  width: 100%;
  flex: 1;
}
#footer-content {
  height: 20px;
}
.foot-notes {
  justify-content: center;
  margin-bottom: 10px;
}

.fade-transform-leave-active,
.fade-transform-enter-active {
  transition: all 0.3s;
}

.fade-transform-enter-from {
  opacity: 0;
  transform: translateX(-30px);
}

.fade-transform-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
</style>
